import { freddyTheme as theme } from '@coolblue-development/freddy';
import { Direction, Size, Version } from '../EnergyLabel.types.js';
const LegacyColors = ['#00A950', '#51BB3F', '#C2D434', '#FFF102', '#FDB815'];
const DefaultColors = ['#01A550', '#4CB748', '#BDD62E', '#FEF104', '#FDB815', '#F36E20', '#ED1D24'];
const DefaultOffsets = {
    [Direction.left]: {
        [Size.small]: 7,
        [Size.medium]: 8,
        [Size.large]: 9,
    },
    [Direction.right]: {
        [Size.small]: 9,
        [Size.medium]: 10,
        [Size.large]: 12,
    },
};
const LegacyFontSizes = {
    [Size.small]: 'md',
    [Size.medium]: 'xl',
    [Size.large]: '3xl',
};
const getLegacyFontStyles = (size) => {
    const fontSize = theme.typography.fontSize[LegacyFontSizes[size]];
    const xlFontSize = theme.typography.fontSize[size === Size.large ? '4xl' : LegacyFontSizes[size]];
    return {
        fontSize,
        lineHeight: fontSize,
        [theme.breakpoint.minWidth('sm')]: {
            fontSize: xlFontSize,
            lineHeight: xlFontSize,
        },
    };
};
const getLegacyPadding = (size) => {
    if (size === Size.small) {
        return `0 ${theme.spacing[100]}`;
    }
    if (size === Size.large) {
        return `0 ${theme.spacing[200]}`;
    }
    return `0 ${theme.spacing[100]}`;
};
const getLegacyBorderWidth = (size) => {
    return `${getTemplateSizeProps(size).height / 2}px ${theme.spacing[200]} ${getTemplateSizeProps(size).height / 2}px 0`;
};
export const getTemplateColor = ({ level, version, }) => {
    var _a, _b;
    if (version === Version.legacy) {
        return (_a = LegacyColors[level]) !== null && _a !== void 0 ? _a : LegacyColors.slice(-1).pop();
    }
    return (_b = DefaultColors[level]) !== null && _b !== void 0 ? _b : DefaultColors.slice(-1).pop();
};
export const getTemplateSizeProps = (size) => {
    return {
        height: 20,
        width: 38,
        ...(size === Size.small && { height: 18, width: 34 }),
        ...(size === Size.large && { height: 24, width: 46 }),
    };
};
export const getContentSizeProps = (size) => {
    return {
        height: 20,
        width: 20,
        ...(size === Size.small && { height: 18, width: 18 }),
        ...(size === Size.large && { height: 24, width: 24 }),
    };
};
export const getLegacyTemplateStyles = ({ direction, level, size = Size.medium, version = Version.default, }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    '&::before': {
        borderStyle: 'solid',
        borderWidth: getLegacyBorderWidth(size),
        borderColor: `transparent ${getTemplateColor({ level, version })} transparent transparent`,
        content: '""',
        height: 0,
        top: 0,
        width: 0,
        ...(direction === Direction.right && {
            order: 1,
            transform: 'rotate(180deg)',
        }),
    },
});
export const getTemplateContainerStyles = (clickable) => ({
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    border: 0,
    padding: 0,
    background: 'unset',
    cursor: clickable ? 'pointer' : 'unset',
});
export const getLegacyContentStyles = ({ direction, level, size = Size.medium, version = Version.default, }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    backgroundColor: getTemplateColor({ level, version }),
    borderRadius: direction === Direction.left ? '0 4px 4px 0' : '4px 0 0 4px',
    color: theme.color.background.base,
    fontWeight: theme.typography.h2.fontWeight,
    height: getTemplateSizeProps(size).height,
    justifyContent: 'center',
    padding: getLegacyPadding(size),
    textAlign: 'center',
    ...getLegacyFontStyles(size),
});
export const getContentContainerStyles = ({ direction = Direction.left, size = Size.medium, version = Version.default, }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    left: version === Version.default ? DefaultOffsets[direction][size] : 0,
    position: version === Version.legacy ? 'relative' : 'absolute',
    top: 0,
});
export const getContainerStyles = ({ imageId, direction }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    flexWrap: 'wrap',
    flexDirection: direction === Direction.right ? 'row' : 'row-reverse',
    gap: theme.spacing[200],
    ...(!!imageId && {
        cursor: 'pointer',
    }),
    minHeight: theme.spacing[600],
    minWidth: theme.spacing[600],
});
export const getModalContainerStyles = () => ({
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
    '& img': {
        height: 'auto',
        width: '100%',
        [theme.breakpoint.maxWidth('sm')]: {
            width: 180,
        },
    },
});
//# sourceMappingURL=EnergyLabel.styles.js.map